import { UserOutlined } from "@ant-design/icons";
import { useLocalStorage } from "@uidotdev/usehooks";
import { Avatar, Typography } from "antd";
import { useDataQuery, useNewApi } from "hooks/useData";
import { useTexts } from "hooks/useTexts";
import { useUser } from "hooks/useUser";
import React from "react";
import "./PersonBlock.css";
import swapIcon from "static/icons/swap.svg";
import BubbleButton from "ui/BubbleButton";

const { Link } = Typography;

const collectivePersonId = 2;

export const usePersonBlock = (
  meta: { author?: number } | undefined,
  isCreating: boolean | string | null | undefined,
) => {
  const { personId, canPublishAsCollective } = useUser();
  const { txt } = useTexts("case");
  const [isCollectivePerson, setIsCollectivePerson] = useLocalStorage(
    "isCollectivePerson",
    0,
  );

  const canSetCollective = canPublishAsCollective && isCreating;
  const isUsingCollectivePerson = !!(canSetCollective && isCollectivePerson);

  const people = useDataQuery(useNewApi ? "people/" : "people");

  const collectivePerson =
    //@ts-ignore
    people?.find((p) => p.id === collectivePersonId) ?? people?.[0];

  const authorPerson =
    //@ts-ignore
    people?.find((p) => p.id === meta?.author) ??
    //@ts-ignore
    // people?.find((p) => p.id === collectivePersonId) ??
    people?.[0];

  const userPerson =
    //@ts-ignore
    people?.find((p) => p.id === personId) ??
    //@ts-ignore
    // people?.find((p) => p.id === collectivePersonId) ??
    people?.[0];

  const person = isUsingCollectivePerson
    ? collectivePerson
    : isCreating
      ? userPerson
      : authorPerson;

  const personLink = person?.id ? `/#/people/${person.id}` : undefined;

  const avatarElement =
    person?.avatarUrl || person?.avatar ? (
      <Link
        href={personLink}
        className="personAvatarLink"
      >
        <Avatar
          size="large"
          src={person?.avatarUrl || person?.avatar}
        />
      </Link>
    ) : (
      <UserOutlined />
    );

  const personFirstAndSecondName = `${person?.firstName || ""}${
    person?.firstName && person?.secondName ? " " : ""
  }${person?.secondName || ""}`;

  const personName =
    person?.name ||
    personFirstAndSecondName ||
    txt("unknown_author", "Неизвестный");

  const personBlock = (
    <div>
      {canSetCollective && (
        <BubbleButton
          className="swap"
          size="s"
          onClick={() => setIsCollectivePerson(isCollectivePerson ? 0 : 1)}
          icon={swapIcon}
          square={true}
        />
      )}{" "}
      <Link
        href={personLink}
        className="personNameLink"
        style={{ fontWeight: 600 }}
      >
        {personName || ""}
      </Link>
    </div>
  );

  return { personBlock, avatarElement, isUsingCollectivePerson };
};
